export const zIndexManager = new (class {
	constructor() {
		this.zIndex = 1001;
	}

	next() {
		return this.zIndex++;
	}

	bringToTop(element) {
		angular.element(element).css('zIndex', this.next());
	}
})();
